<template>
    <va-edit-layout>
        <ShipmentEventShipmentItemFee-form
            :id="id"
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItemFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
